import Vue from "vue";
import moment from 'moment';
import store from '../store';

Vue.filter('time', function (dateStr) {
  return dateStr ? moment(dateStr).format(store.state.mainConfig.timeFormat) : null;
})
